import { AnimaliaNarrativeBlock } from './AnimaliaNarrativeBlock';
import { AnimaliaTaxonomyEntry } from './AnimaliaTaxonomyEntry';

interface AnimaliaImage {
  readonly src: string;
  readonly alt: string;
  readonly license: AnimaliaImageLicense | null;
}

interface AnimaliaImageLicense {
  readonly name: string | null;
  readonly url: string | null;
  readonly artist: string | null;
  readonly credit: string | null;
  readonly attributionRequired: boolean;
  readonly source: string | null;
}

interface AnimaliaWikipedia {
  readonly url: string;
}

export class AnimaliaListItem {
  constructor(
    public readonly id: string,
    public readonly slug: string,
    public readonly scientificName: string,
    public readonly completed: boolean,
    public readonly commonName: string | null,
    public readonly family: string | null,
    public readonly continent: string | null,
    public readonly country: string | null,
    public readonly image: AnimaliaImage | null,
    public readonly wikipedia: AnimaliaWikipedia | null,
    public readonly narrativeBlocks: ReadonlyArray<AnimaliaNarrativeBlock>,
    public readonly authority: string | null,
    public readonly taxonomicRank: string | null,
    public readonly taxonomyEntries: ReadonlyArray<AnimaliaTaxonomyEntry>,
  ) {}

  getGenus(): string | null {
    const [genus] = this.scientificName.trim().split(/\s+/);
    return genus && genus.trim() !== '' ? genus : null;
  }

  getSpeciesLabel(): string {
    return this.getTaxonomyValue('species') ?? this.scientificName;
  }

  getPrimaryNarrativeBlock(): AnimaliaNarrativeBlock | null {
    return this.narrativeBlocks[0] ?? null;
  }

  getTaxonomyValue(level: string): string | null {
    const match = this.taxonomyEntries.find((entry) => entry.level === level);

    return match?.value ?? null;
  }
}
